import { addOrUpdateUniqueStyleTagBeforeSpecificElementInHead } from "@/lib/canvas/assets/dom-utils";
import { prefixBuilderAddedCssTagId } from "@/lib/canvas/assets/css-in-head/utils";

export function addOrUpdateGeneratedPresetsInlineCSSInCanvasHead(
  canvasDocument: Document,
  rawCssCode: string
) {
  addOrUpdateUniqueStyleTagBeforeSpecificElementInHead(
    canvasDocument,
    prefixBuilderAddedCssTagId("presets"),
    rawCssCode,
    'meta[name="breakdance:header-assets:css:global-settings"][content="end"]'
  );
}
